import React from 'react'

import * as styles from './getXealCertified.module.scss'

import { Section, Text, Media } from 'common'

import ResellerModal from 'components/modals/ResellerModal'

export default function GetXealCertified({ media, title, subtitle, ctas }) {
  return (
    <Section className={styles.section}>
      <div className={styles.content}>
        <div className={styles.text}>
          <Text title={title} titleAs="h3" subtitle={subtitle} />

          <div className={styles.cta}>
            <ResellerModal arrow text={ctas[0].text} btn theme="light" />
          </div>
        </div>

        <Media {...media} />
      </div>
    </Section>
  )
}
